/**
 * Case Members Service
 * API calls for team collaboration
 */
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

const caseMembersService = {
  /**
   * Get all members of a case
   */
  async getCaseMembers(caseId) {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_URL}/api/cases/${caseId}/members`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    // Backend returns {members: [...], total: N}, extract just the array
    return response.data.members || [];
  },

  /**
   * Add a member to a case
   */
  async addMember(caseId, userId, role) {
    const token = localStorage.getItem('token');
    const response = await axios.post(
      `${API_URL}/api/cases/${caseId}/members`,
      {
        case_id: caseId,
        user_id: userId,
        role: role
      },
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    return response.data;
  },

  /**
   * Remove a member from a case
   */
  async removeMember(caseId, userId) {
    const token = localStorage.getItem('token');
    const response = await axios.delete(
      `${API_URL}/api/cases/${caseId}/members/${userId}`,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    return response.data;
  },

  /**
   * Update member's role in a case
   */
  async updateMemberRole(caseId, userId, newRole) {
    const token = localStorage.getItem('token');
    const response = await axios.patch(
      `${API_URL}/api/cases/${caseId}/members/${userId}/role`,
      { role: newRole },
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    return response.data;
  },

  /**
   * Get all cases where user is a team member
   */
  async getMyTeamCases() {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_URL}/api/cases/my-cases/team`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  /**
   * Get all lawyers in tenant (for adding members)
   */
  async getTenantLawyers() {
    const token = localStorage.getItem('token');
    // This endpoint might need to be created, or we can use existing users endpoint
    const response = await axios.get(`${API_URL}/api/users`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    // Filter for lawyers/assistants
    return response.data.filter(u => 
      ['LAWYER', 'ADMIN', 'TENANT_ADMIN'].includes(u.role)
    );
  }
};

export default caseMembersService;
